export default __webpack_public_path__ + "static/media/Trackers.1409c5ea.png";